import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles'
import styled from "styled-components";
import Web3 from "web3";

import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";
import * as s from "../../styles/components/Tile/mintTileStyle";
import styles from '../../styles/components/Tile/mintTileStyle'

const useStyles = makeStyles(styles)

const MintLive = props => {
    const { data, blockchain, getData, callback } = props
    const dispatch = useDispatch();
    const classes = useStyles()
    const [claimingNft, setClaimingNft] = useState(false);
    const [mintAmount, setMintAmount] = useState(1);
    const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);

    const decrementMintAmount = () => {
        let newMintAmount = mintAmount - 1;
        if (newMintAmount < 1) {
          newMintAmount = 1;
        }
        setMintAmount(newMintAmount);
      };
    
      const incrementMintAmount = () => {
        let newMintAmount = mintAmount + 1;
        if (newMintAmount > data.maxPerWallet) {
          newMintAmount = data.maxPerWallet;
        }
        setMintAmount(newMintAmount);
      };
      
    function renderMintButton(param) {
        let mintText;

        if (claimingNft) {
            mintText = "Minting... Please wait"
        } else {
            mintText = "Mint"
        }

        switch(param) {
            case 'Whitelist':
                return (
                    <><h2 className={classes.supplyTitle}>Current Phase: Whitelist only</h2>
                    <s.SpacerMedium></s.SpacerMedium>
                    {data.proof === undefined ? (
                        <h2 className={classes.supplyTitle}>You are not whitelisted</h2>
                    ) : (
                        <>
                        <h2 className={classes.supplyTitle}>You are whitelisted for {data.maxPerWallet} free mints</h2>
                        <s.SpacerMedium></s.SpacerMedium>
                        <s.StyledButton
                            disabled={claimingNft ? 1 : 0}
                            onClick={(e) => {
                                e.preventDefault();
                                wlClaim();
                                getData();
                            } }>
                            {mintText}
                        </s.StyledButton></>
                    )}
                    </>)
            case 'Public':
                return (
                    <>
                    <h2 className={classes.supplyTitle}>Current Phase: Public Mint</h2>
                    <s.SpacerMedium></s.SpacerMedium>
                    <h2 className={classes.supplyTitle}>{Web3.utils.fromWei(data.cost)} each, {data.maxPerWallet} per wallet/tx</h2>
                        <s.SpacerMedium></s.SpacerMedium>
                        <s.Container ai={"center"} jc={"center"} fd={"row"}>
                            <s.StyledRoundButton
                                disabled={claimingNft ? 1 : 0}
                                onClick={(e) => {
                                e.preventDefault();
                                decrementMintAmount();
                                }}
                            >
                                -
                            </s.StyledRoundButton>
                            <s.SpacerMedium />
                            <s.TextDescription
                                style={{
                                textAlign: "center",
                                color: "var(--accent-text)",
                                }}
                            >
                                {mintAmount}
                            </s.TextDescription>
                            <s.SpacerMedium />
                            <s.StyledRoundButton
                                disabled={claimingNft ? 1 : 0}
                                onClick={(e) => {
                                e.preventDefault();
                                incrementMintAmount();
                                }}
                            >
                                +
                            </s.StyledRoundButton>
                        </s.Container>
                        <s.SpacerLarge></s.SpacerLarge>
                        <s.StyledButton
                            disabled={claimingNft ? 1 : 0}
                            onClick={(e) => {
                                e.preventDefault();
                                publicClaim();
                                getData();
                            } }
                        >
                            {mintText}
                        </s.StyledButton>
                    </>)
            default:
                return (
                    <><h2 className={classes.supplyTitle}>Minting is not live yet</h2></>
                    )
        }
    }

    function publicClaim() {
        setFeedback(`Minting Happy Sloths.`);
        setClaimingNft(true);
        blockchain.smartContract.methods
            .mint(mintAmount)
            .send({
                to: blockchain.smartContract._address,
                from: blockchain.account,
                value: String(mintAmount * data.cost)
            })
            .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                setClaimingNft(false);
            })
            .then((receipt) => {
                console.log(receipt);
                setFeedback(
                    `Successfully minted Happy Sloths`
                );
                setClaimingNft(false);
                dispatch(fetchData(blockchain.account));
                callback(true);
            })
            .catch((error) => {
                // Catch user rejections etc
                setClaimingNft(false);
                console.log(error)
            });
    }

    function wlClaim() {
        setFeedback(`Minting Happy Sloths.`);
        setClaimingNft(true);
        blockchain.smartContract.methods
            .mintToAL(data.proof.address, data.proof.proof)
            .send({
                to: blockchain.smartContract._address,
                from: blockchain.account
            })
            .once("error", (err) => {
                console.log(err);
                setFeedback("Sorry, something went wrong please try again later.");
                setClaimingNft(false);
              })
            .then((receipt) => {
                console.log(receipt);
                setFeedback(
                    `Successfully minted Happy Sloths`
                );
                setClaimingNft(false);
                dispatch(fetchData(blockchain.account));
                callback(true);
            })
            .catch((error) => {
                // Catch user rejections etc
                setClaimingNft(false);
                console.log(error)
            });
    }
  
    return (
        <>
        <h2 className={classes.supplyTitle}>
            {3333 - data.totalSupply} / 3333 Remaining
        </h2>
        <s.SpacerSmall></s.SpacerSmall>
        {Number(data.totalSupply) >= 3333 ? (
            <>
            <h2 className={classes.supplyTitle}>
                The sale has ended.
            </h2>
            </>
            ) : (
                <>{renderMintButton(data.mintMode)}</>
            )}
        </>
    )
}


const MintTile = () => {
    const dispatch = useDispatch();
    const classes = useStyles()
    const blockchain = useSelector((state) => state.blockchain);
    const data = useSelector((state) => state.data);
    const [minted, setMinted] = useState(false);
    let proof = undefined;
    let display;

    const getData = () => {
        if (blockchain.account !== "" && blockchain.smartContract !== null) {
            dispatch(fetchData(blockchain.account));
        }
    };

    const handleCallback = (childData) => {
        setMinted(childData)
    };

    const getDisplay = ()  => {
        if (minted === true) {
            display = 
                <h2 className={classes.supplyTitle}>
                Successfully minted, check OS to see your NFTs.
                </h2>
        }
        else if (data.userMintAmt !== 0 && data.userMintAmt >= data.maxPerWallet) {
            display =                 
                <h2 className={classes.supplyTitle}>
                    Max mints per wallet reached.
                </h2>
        }
        else {
            display = 
                <>
                <h2 className={classes.mintTitle}>Mint</h2>
                <s.SpacerSmall></s.SpacerSmall>
                {blockchain.account === "" ||
                    blockchain.smartContract === null ? (
                        <s.StyledButton
                            onClick={(e) => {
                            e.preventDefault();
                            dispatch(connect());
                            getData();
                            }}
                        >
                        CONNECT
                        </s.StyledButton>
                    ): (
                    <MintLive
                        data={data}
                        blockchain={blockchain}
                        getData={getData}
                        callback={handleCallback}
                    ></MintLive>
                )}
                </>
        }
        return display;
    }

    useEffect(() => {
        getData();
    }, [blockchain.account]);
    
    return (
        <s.Container
            style={{
              backgroundColor: "teal",
              height: '60vh',
              padding: 24,
              borderRadius: 24,
              justifyContent:'center', 
              alignItems:'center',
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)"}}>
            {getDisplay()}
        </s.Container>
    )
}

export default MintTile